import { Component, Inject, OnInit, Optional } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { AuthenticationService } from "../../../core/services/authentication.service";
import { CommonService } from 'src/app/core/services/common.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserRegistrationComponent } from '../user-registration/user-registration.component';
import { NeverBounceService } from 'src/app/core/services/neverbounce.service';

@Component({
  selector: 'app-user-login',
  templateUrl: './user-login.component.html',
  styleUrls: ['./user-login.component.scss']
})
export class UserLoginComponent implements OnInit {
  loginForm: UntypedFormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  errorText: String;
  showResponseMessage: boolean;
  model: any = {};
  public emailPattern = "^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}$";
  auth = ''
  key = ''
  gotocart = false
  userObj = {}

  constructor(
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private commonService: CommonService,
    private nbService: NeverBounceService
, 
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any = null,
    @Optional() public dialogRef: MatDialogRef<UserLoginComponent> = null
  ) { }

  ngOnInit() {
    this.auth = this.route.snapshot.queryParams['auth'] || ''
    this.key = this.route.snapshot.queryParams['key'] || ''
    this.gotocart = this.route.snapshot.queryParams['gotocart'] || false
    let email = this.route.snapshot.queryParams['email'] || this.data?.email
    if (this.auth && this.key) {
      this.getUser()
    }
    this.createLoginForm(email)
    //this.nbService.loadScript();

  }

  onBlur(event: FocusEvent): void {
    const input = event.target as HTMLInputElement;

    if (!input) {
      console.warn('⚠️ No input target found on blur.');
      return;
    }

    this.nbService.validateInput(input).catch(err => {
      console.warn('NeverBounce validation skipped:', err);
    });
  }


  createLoginForm(email?) {
    this.loginForm = this.formBuilder.group({
      email: new UntypedFormControl(email || "", [
        Validators.required,
        Validators.pattern(this.emailPattern),
      ]),
      password: new UntypedFormControl("", Validators.required),
    });
  }

  login() {
    let role: any;
    let isAuthorized = false;
    if (this.loginForm.valid) {
      this.loading = true;
      this.authenticationService.login(this.loginForm.value).subscribe(
        data => {
          window.top.postMessage("cart count-" + data.cartTotal, "*");
          role = data.user.roles[0];
          isAuthorized = role.name === "ENDUSER";
          if (isAuthorized) {
            if (this.data) {
              this.dialogRef.close();
              this.router.navigateByUrl('enduser/useraccount/my-stores');
              window.parent.postMessage(data, "*");
            } else {
            window.parent.postMessage(data, "*");
            window.parent.postMessage("close popup", "*");
            }
          } else {
            this.commonService.openErrorSnackBar("Authorization failed", "");
            this.loading = false;
          }
        },
        error => {
          this.commonService.openErrorSnackBar(error.error.message, "");
          this.loading = false;
        });
    }
  }

  signUp() {
    if (this.auth)
      this.router.navigateByUrl(
        'enduser/signup' +
        '?auth=' + this.auth +
        '&key=' + this.key +
        '&gotocart=' + this.gotocart
        );
        // , { queryParams: { auth: this.auth, key: this.key, gotocart: this.gotocart } }
    else
      this.router.navigateByUrl('enduser/signup');
  }

  forgotPassword() {
    let url = 'enduser/forgot';
    if (this.data) {
      url += '?isFromSelectTeam=true';
    }
    this.router.navigateByUrl(url);
  }

  getUser() {
    this.authenticationService.getUserByAuthKey(this.auth, this.key).subscribe(res => {
      if (res.data.emailConfirmed === false) {
        localStorage.setItem('signupUser', JSON.stringify(res.data))
        // this.signUp()
      }
    })
    if (this.userObj) {

    }
  }
}
